import { KpiPropsSchema } from "../schemas/kpi.types";
import { Spinner } from "reactstrap";
import React from "react";

export const KPICard: React.FC<KpiPropsSchema> = ({ title, value, loading }) => {
    return (
        <div className="kpi-card-custom">
            <div className="d-flex flex-column justify-content-between h-100">
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center h-100">
                        <Spinner size="sm" color="light" />
                    </div>
                ) : (
                    <div>
                        <div className="kpi-title mb-3">{title}</div>
                        <div className="kpi-value">{value}</div>
                    </div>
                )}
            </div>
        </div>
    );
};